var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlassSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6573 12.999L11.1504 9.4922C11.9479 8.30831 12.3413 6.82911 12.1307 5.25294C11.7715 2.57199 9.57425 0.390247 6.89065 0.0504913C2.90071 -0.454382 -0.454367 2.9007 0.050535 6.89064C0.390379 9.5754 2.57241 11.7744 5.25366 12.1318C6.82983 12.3425 8.30932 11.9492 9.49292 11.1516L12.9998 14.6584C13.4574 15.116 14.1995 15.116 14.6571 14.6584C15.1143 14.2002 15.1143 13.4561 14.6573 12.999ZM2.31741 6.09376C2.31741 4.02599 3.99964 2.34376 6.06741 2.34376C8.13518 2.34376 9.81741 4.02599 9.81741 6.09376C9.81741 8.16154 8.13518 9.84376 6.06741 9.84376C3.99964 9.84376 2.31741 8.16212 2.31741 6.09376Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassSolid);
export default __webpack_public_path__ + "static/media/magnifying-glass-solid.5f724664f086610c1af8b3f90277dfb6.svg";
export { ForwardRef as ReactComponent };